<div class="flex flex-col min-h-screen w-full">
  <app-organizer-hero-section></app-organizer-hero-section>
  <main class="flex-1 w-full">
    <app-organizer-flow-section></app-organizer-flow-section>
    <app-organizer-line></app-organizer-line>
    <app-organizer-grow></app-organizer-grow>
    <app-organizer-client></app-organizer-client>
    <app-organizer-help></app-organizer-help>
    <app-organizer-testimonial></app-organizer-testimonial>
    <app-organizer-interest></app-organizer-interest>
  </main>
  <app-footer></app-footer>
</div>
